import React from 'react';

import type { OrderPreference } from '../../utils/dnd-data';
import type { AnalyticsEventHandler } from '../../utils/use-item-drop';

import { NestedItemsActionsAdapter } from './utils';
type UseNavigationItemActions<T> = (args: {
	currentItems: T[];
	currentOrder: OrderPreference;
	entityAri: string;
	fireAnalyticsEvent?: AnalyticsEventHandler;
	getItemId: (item: T) => string;
	item: { id: string; label: string };
	ownerAri: string;
}) => React.ReactNode;

export const useNavigationItemActions: UseNavigationItemActions<unknown> = ({
	currentItems,
	currentOrder,
	entityAri,
	fireAnalyticsEvent,
	item,
	ownerAri,
	getItemId,
}) => {
	return (
		<NestedItemsActionsAdapter
			currentItems={currentItems}
			currentOrder={currentOrder}
			entityAri={entityAri}
			fireAnalyticsEvent={fireAnalyticsEvent}
			item={item}
			ownerAri={ownerAri}
			getItemId={getItemId}
		/>
	);
};
